export const ButtonsEnum = {
    FreeHand: 1,
    Rectangle: 2,
    Circle: 3,
    Arrow: 4,
    Clear: 5,
  };